module.exports = __webpack_public_path__ + "img/nodata.cbaef44c.png";